export var PartialRestoreType;
(function (PartialRestoreType) {
    PartialRestoreType["FilesPartialRestoreData"] = "FILES_PARTIAL_RESTORE_DATA";
    PartialRestoreType["AwsEbsVolumePartialRestoreData"] = "AWS_EBS_VOLUME_PARTIAL_RESTORE_DATA";
    PartialRestoreType["AzureDiskPartialRestoreData"] = "AZURE_DISK_PARTIAL_RESTORE_DATA";
    PartialRestoreType["GcpDiskPartialRestoreData"] = "GCP_DISK_PARTIAL_RESTORE_DATA";
})(PartialRestoreType || (PartialRestoreType = {}));
